const AUTH_AND_PROFILE_ROUTES = [
  '',
  'login',
  'register',
  'forgotPassword',
  'switchPassword',
  'userProfile',
  'accountDeletion',
  'paymentMethods',
  'addCredit',
  'addCreditCard',
  'addPix',
  'extract',
  'vehicles',
  'vehicles-list',
  'vehicle-detail',
  'coupons',
  'privacy-policy',
  'terms-of-use',
];

export const REDEFINE_PASSWORD = [
  'forgot-password-app',
  'redefinePassword',
  'sucessRedefinePassword',
  // Definicao da primeira senha (conta criada por importacao em lote).
  // Mesmo cabecalho da redefinicao: e a mesma tela, so muda o texto.
  'welcome-password',
  'sucessWelcomePassword',
];

// Combina todas as rotas que precisam de um cabeçalho
export const ALL_WITH_HEADER = [
  ...AUTH_AND_PROFILE_ROUTES,
  ...REDEFINE_PASSWORD,
];

// Rotas que usam o layout web específico
export const WEB_HEADERS = ['redefinePassword', 'sucessRedefinePassword'];

// Rotas que usam o layout SIMPLE_HEADER (apenas a lista de Autenticação/Perfil sem a de Redefinição)
export const SIMPLE_HEADER = AUTH_AND_PROFILE_ROUTES;
